module.exports = "<nav>\n    <app-stats></app-stats>\n</nav>"